var _g, _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEn({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 20,
    viewBox: "0 0 28 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_86_3815)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_86_3815)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 27.5,
    height: 20,
    rx: 2.5,
    fill: "#1A47B8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.42544 0H0.5V3.33333L25.0587 20L28 20V16.6667L3.42544 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.47572 0L28 18.0472V20H27.0471L0.5 1.93408V0H1.47572Z",
    fill: "#F93939"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.381 0H28V3.33333C28 3.33333 10.989 14.4374 3.11905 20H0.5V16.6667L25.381 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28 0H27.1118L0.5 18.0628V20H1.47572L28 1.94868V0Z",
    fill: "#F93939"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5009 0H18.0219V6.16909H28V13.8268H18.0219V20H10.5009V13.8268H0.5V6.16909H10.5009V0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0789 0H16.4211V7.69231H28V12.3077H16.4211V20H12.0789V12.3077H0.5V7.69231H12.0789V0Z",
    fill: "#F93939"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.125,
    y: 0.625,
    width: 26.25,
    height: 18.75,
    stroke: "#F9F2F2",
    strokeWidth: 1.25
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_86_3815"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 27.5,
    height: 20,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_86_3815"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 27.5,
    height: 20,
    rx: 2.5,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEn);
export default __webpack_public_path__ + "static/media/en.524acdf8f778c9410510143e277efdf3.svg";
export { ForwardRef as ReactComponent };